<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Submissions Via API/Non-API</h3>
        </div>

        <div class="mt-2 text-center d-flex justify-content-between">
            <div>
                <label>API</label>
                <h2>{{ api }}</h2>
            </div>
            <div>
                <label>Manual</label>
                <h2>{{ manual }}</h2>
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'SubmissionsChart',
    components: {},
    props: [
        'lenderSubmissions',
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            lenderSubmissionsData: [],
            labelLength: 0,
            datasets: [],
            manual: 0,
            api: 0
        }
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.lenderSubmissionsData = event.lenderSubmissions.lenderSubmissions
            this.labelLength = event.lenderSubmissions.lenderSubmissions.labels.length

            let api = this.lenderSubmissionsData.values.api_subs.map(a => _.toInteger(a))
            let manual = this.lenderSubmissionsData.values.non_api_subs.map(m => _.toInteger(m))

            this.api = _.sum(api)
            this.manual = _.sum(manual)

            this.graphColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.lenderSubmissionsData = event.lenderSubmissions.lenderSubmissions
            this.labelLength = event.lenderSubmissions.lenderSubmissions.labels.length

            let api = this.lenderSubmissionsData.values.api_subs.map(a => _.toInteger(a))
            let manual = this.lenderSubmissionsData.values.non_api_subs.map(m => _.toInteger(m))

            this.api = _.sum(api)
            this.manual = _.sum(manual)

            this.graphColorChange()
        })
    },
    computed: {
        totalLenders() {
            return this.labelLength;
        }
    },
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        }
    }
}
</script>

<style scoped>
.move {
    cursor: move;
}

.lender-logo {
    height: 42px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
}

.lender-logo .lender-text {
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
